/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */
import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const CustomIndica24 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="Custom Indica 24">
      <path
        fill="#0E0E0E"
        d="M11.036 1.53a2 2 0 0 1 1.928 0l8 4.4A2 2 0 0 1 22 7.683v8.634a2 2 0 0 1-1.036 1.753l-8 4.4a2 2 0 0 1-1.928 0l-8-4.4A2 2 0 0 1 2 16.317V7.683A2 2 0 0 1 3.036 5.93l8-4.4Z"
        className="Fill-Main"
      />
      <path
        fill="#fff"
        d="M11.06 17V7.77h1.884V17H11.06Z"
        className="Details"
      />
    </g>
  </svg>
);

const SIZE_MAP = {
  sm: CustomIndica24,
  md: CustomIndica24,
  lg: CustomIndica24,
  xl: CustomIndica24,
  xxl: CustomIndica24,
  xxxl: CustomIndica24,
};

export const CustomIndicaIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'custom-indica-icon'}
      icon={SIZE_MAP[size]}
      {...props}
      size={size}
    />
  );
};
